'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _adminsByCategoryBar = require('./admins-by-category-bar.component');

var _adminsByCategoryBar2 = _interopRequireDefault(_adminsByCategoryBar);

var _adminsByCategoryBar3 = require('./admins-by-category-bar.service');

var _adminsByCategoryBar4 = _interopRequireDefault(_adminsByCategoryBar3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports.administrationsByCategoryBar', [_angularUiRouter2.default]).component('administrationsByCategoryBar', _adminsByCategoryBar2.default).service('AdminsByCategoryBarService', _adminsByCategoryBar4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('administrationsByCategoryBar', {
    parent: 'reports',
    url: '/administrations-by-category-bar',
    component: 'administrationsByCategoryBar',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-bar/admins-by-category-bar.module.js